<template>
  <section>
    <slot />
  </section>
</template>

<style scoped>
  section {
    @media screen and (min-width: 992px) {
      display: grid;
      gap: 5rem;
      grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
      grid-template-rows: repeat(auto-fit);
    }
  }
</style>
